import { getDataNeta, getPageTitle } from '@portal-internet/core';
import __isEmpty from 'lodash/isEmpty';
import __isNumber from 'lodash/isNumber';
import __isUndefined from 'lodash/isUndefined';
import { dataResources } from '../../../utils/constants';

const NOINFORMAT = 'No Informat';
const CATINFO = '3CatInfo';
const UNIVERS3CAT = 'Univers 3Cat';

const _addUnivers3cat = (program, domain, listTags) => {
    if (program !== NOINFORMAT && domain === 'TVC') {
        return listTags.includes(UNIVERS3CAT) ? listTags : listTags.concat(`,${UNIVERS3CAT}`);
    }
    return listTags;
};
const _defineDeviceUID = (deviceUid) => {
    if (deviceUid) {
        window.getDeviceUID =
            window.getDeviceUID ||
            function () {
                return deviceUid;
            };
    }
};
const _val = (value) => {
    return typeof value !== 'undefined' && value !== NOINFORMAT ? value : '';
};

const _getTempsPublicacio = (value) => {
    let dat,
        dat2 = new Date();
    if (value !== '' && typeof value !== 'undefined' && value !== NOINFORMAT) {
        const [data, time] = value?.split(' ');
        let [d, m, y] = data.split(/\D/);
        let [hora, min] = time.split(':');

        dat = new Date(y, m - 1, d, hora, min);
        return Math.floor(
            (Date.UTC(dat2.getFullYear(), dat2.getMonth(), dat2.getDate(), dat2.getHours(), dat2.getMinutes()) -
                Date.UTC(dat.getFullYear(), dat.getMonth(), dat.getDate(), dat.getHours(), dat.getMinutes())) /
                (1000 * 60)
        ).toString();
    } else {
        return NOINFORMAT;
    }
};

const _getHoraMinuts = (value) => {
    if (value !== '' && typeof value !== 'undefined' && value !== NOINFORMAT) {
        const [data, time] = value?.split(' ');
        let [h, m] = time?.split(':');
        if (h || m) {
            return h + ':' + m;
        }
    }
    return false;
};

const _getCurrentUrl = (router) => {
    let url = router.asPath,
        indexParams = url.indexOf('?');
    url = indexParams > 0 ? url.substring(0, indexParams) : url;
    const indexHash = url.indexOf('#');
    url = indexHash > 0 ? url.substring(0, indexHash) : url;
    return 'https://' + dataResources.domainCCMA + url;
};

const _getCurrentFullUrl = (router) => {
    const url = router.asPath;
    return 'https://' + dataResources.domainCCMA + url;
};

const _getURLQueryString = (router) => {
    const indexParams = router.asPath.indexOf('?');
    return indexParams > 0 ? router.asPath.substring(indexParams + 1) : '';
};

const _getLoginState = (isAuthenticated) => {
    let estat = 'Sense fer login';
    if (isAuthenticated) {
        estat = 'Amb login CCMA';
    }
    return estat;
};

const _getFormats = (formats, domini = NOINFORMAT, programaWeb = NOINFORMAT) => {
    if (__isUndefined(formats) || __isEmpty(formats)) return formats;

    const llistaFormats = [
        ...new Set(
            formats
                .filter((format) => format.main === true)
                ?.map((format) => format.desc)
                ?.concat(formats.map((format) => format.desc))
        )
    ]?.join(',');

    return _addUnivers3cat(programaWeb, domini, llistaFormats);
};

const _getAutors = (autors) => {
    if (__isUndefined(autors) || __isEmpty(autors)) return autors;
    return autors?.map((autor) => autor.nom).join(',');
};
const _getIdUsuari = (id) => {
    return id ? btoa(id) : '';
};

const _getIdentificadorClick = (valor) => {
    if (!valor) return '';
    return /^\d+:[^\d].+/.test(valor) ? valor : `1:${valor?.replace(':', '.')}`;
};

const _getFileInfo = (props) => {
    const {
        tipus,
        isWebviewActive,
        evar1,
        evar2,
        evar3,
        evar4,
        subseccioNivell1,
        evar7,
        evar8,
        evar9,
        font,
        permatitle,
        id,
        data_publicacio,
        autor,
        autors,
        pagename
    } = props;
    let fileInfo = {};

    const APPMOBILS = 'Aplicacions Mòbils',
        APP3CATPLAY = 'App: 3catinfo';

    if (tipus.includes('item')) {
        fileInfo = {
            pagename: pagename || permatitle || evar4 || NOINFORMAT,
            titol: permatitle || [evar4, CATINFO].join(' ') || NOINFORMAT,
            evar3: evar3 || NOINFORMAT,
            evar4: evar4 || NOINFORMAT,
            subseccioNivell1: subseccioNivell1 || NOINFORMAT,
            evar7: evar7 || NOINFORMAT,
            evar8: evar8 || NOINFORMAT,
            evar9: evar9 || NOINFORMAT,
            evar14: id || NOINFORMAT,
            evar19: data_publicacio,
            evar25: tipus == 'itemnoti' ? (font == 'sACN' ? 'ACN' : CATINFO) : NOINFORMAT,
            evar86: _getAutors(autors) || autor || NOINFORMAT,
            dataPublicacio: data_publicacio || NOINFORMAT
        };

        if (isWebviewActive) {
            fileInfo = { ...fileInfo, evar1: APPMOBILS, evar2: APP3CATPLAY };
        }

        return fileInfo;
    } else if (tipus === 'mapaweb') {
        return {
            pagename: pagename,
            titol: pagename,
            evar1: isWebviewActive ? APPMOBILS : evar1,
            evar2: isWebviewActive ? APP3CATPLAY : evar2,
            evar7: isWebviewActive ? `${evar7} app` : evar7,
            subseccioNivell1: evar4 || NOINFORMAT
        };
    }
    return {};
};

const setGlobalEvar = (index, eVar) => {
    window.globalEvars = window.globalEvars || {};
    window.globalEvars[index] = eVar;
};

const setDigitalData = (props) => {
    let fileInfo;
    const {
        titol,
        prefix,
        sufix,
        evar1,
        evar2,
        evar3,
        evar4,
        evar5,
        evar7,
        evar8,
        evar9,
        evar14,
        evar19,
        evar25,
        evar40,
        evar41,
        evar64,
        evar69,
        evar80,
        evar83,
        evar84,
        evar86,
        agrupacions,
        dataPublicacio,
        status,
        isAuthenticated,
        id,
        deviceUid,
        viewport,
        router,
        temes,
        tipus,
        tiraOrigen,
        tiraTitles,
        domini
    } = props;

    fileInfo = _getFileInfo(props);
    const _getValor = (vParam, vItem = '', vDefecte = '') => {
        if ((!__isEmpty(vParam) && vParam !== NOINFORMAT) || __isNumber(vParam)) {
            return _val(vParam);
        }
        if (vItem !== NOINFORMAT && (!__isEmpty(vItem) || __isNumber(vItem))) {
            return _val(vItem);
        }
        return vItem === NOINFORMAT ? vItem : vDefecte;
    };

    if (tipus == 'errorPage' && !__isEmpty(window) && !__isEmpty(window.s)) {
        window.s.pageType = 'errorPage';
    }

    const _getTemes = () => {
        if (evar3 === 'Temes') {
            return fileInfo?.subseccioNivell1 !== NOINFORMAT
                ? fileInfo?.subseccioNivell1
                : _getValor(evar4, fileInfo?.evar4, NOINFORMAT);
        } else {
            return _getValor(fileInfo?.temes, _getFormats(temes, domini, evar8 || NOINFORMAT), NOINFORMAT);
        }
    };

    return {
        user: {
            userLogin: _getLoginState(isAuthenticated), // 'Sense fer login' || 'Amb login CCMA' || 'Amb login Super3'
            idUsuari: _getIdUsuari(id), // id del registre de la ccma evar71 //REVISAR
            idBigData: deviceUid // S'agafa de Matr
        },
        page: {
            pageName: tipus == 'errorPage' ? '' : _getValor(fileInfo?.pagename, getPageTitle(prefix, titol, '', '')),
            actualPageName: _getValor(fileInfo?.pagename, getPageTitle(prefix, titol, sufix, '')),
            viewport: viewport,
            web: _getValor(evar1, fileInfo?.evar1, 'CCMA'),
            seccio: _getValor(evar2, fileInfo?.evar2, 'Notícies'),
            subseccio: _getValor(fileInfo?.evar3, evar3, 'Notícies'), // Volem que pugui retornar el camp com a 'No informat'
            subseccioNivell1:
                fileInfo?.subseccioNivell1 !== NOINFORMAT
                    ? fileInfo?.subseccioNivell1
                    : _getValor(evar4, fileInfo?.evar4, NOINFORMAT),
            subseccioNivell2: _getValor(evar5, fileInfo?.evar5, NOINFORMAT),
            URL: _getCurrentUrl(router), //si per mapaweb la canviem, no tenim la URL actual
            tipusPagina: tipus == 'errorPage' ? 'errorPage' : _getValor(evar7, fileInfo?.evar7, NOINFORMAT),
            programaWeb: _getValor(evar8, fileInfo?.evar8, NOINFORMAT),
            areaTematicaWeb: _getFormats(evar9, domini, evar9 || NOINFORMAT),
            idDeliverty: _getValor(evar14, fileInfo?.evar14, NOINFORMAT).toString(),
            dataEmissio: _getValor(getDataNeta(_getValor(evar19, fileInfo?.evar19)), NOINFORMAT),
            productorContingut: _getValor(evar25, fileInfo?.evar25, NOINFORMAT),
            cercadorKW: typeof window !== 'undefined' ? window.globalEvars?.eVar40 || _val(evar40) : NOINFORMAT,
            cercadorResultats: typeof window !== 'undefined' ? window.globalEvars?.eVar41 || _val(evar41) : NOINFORMAT,
            consent: typeof window !== 'undefined' ? window.globalEvars?.eVar89 || NOINFORMAT : NOINFORMAT,
            origenClic: tiraOrigen || NOINFORMAT,
            relacionats: tiraTitles || NOINFORMAT,
            formatva: _getValor(fileInfo?.evar69, _getFormats(evar69), NOINFORMAT),
            categoriaAgrupadora: _getValor(fileInfo?.agrupacions, _getFormats(agrupacions), NOINFORMAT),
            temes: _getTemes(),
            campanyesInternes: _val(evar83),
            lectorPantalla: _val(evar84),
            autor: _getValor(fileInfo?.evar86, evar86),
            horaEmissio: _getValor(_getHoraMinuts(_getValor(evar19, fileInfo?.evar19)), NOINFORMAT),
            contingutMultimedia: 'PER_DEFINIR',
            urlSencera: _getCurrentFullUrl(router),
            queryStringUrl: _getURLQueryString(router),
            tempsPublicacio: _getTempsPublicacio(_getValor(dataPublicacio, fileInfo?.dataPublicacio)),
            status: _val(status),
            codiEtic: evar80 || NOINFORMAT,
            indentificadorClic: _getIdentificadorClick(evar64)
        }
    };
};

const setGlobalEvars = (digitalData) => {
    setGlobalEvar('eVar63', digitalData.user.userLogin);
    setGlobalEvar('eVar71', digitalData.user.idUsuari);
    setGlobalEvar('eVar87', digitalData.user.idBigData);
    _defineDeviceUID(digitalData.user.idBigData);
};

const windowSetGlobalEvar = (evar, params) => {
    window.getGlobalEvar =
        window.getGlobalEvar ||
        function (evar) {
            window.globalEvars = window.globalEvars || {};
            window.s = window.s || {};
            window.globalEvars[evar] = window.globalEvars[evar] || window.s[evar];
            return window.globalEvars[evar];
        };

    let value = '';
    switch (evar) {
        case 'eVar71':
            value = _getIdUsuari(params?.id);
            break;
        case 'eVar63':
            value = _getLoginState(params?.isAuthenticated);
            break;
    }

    setGlobalEvar(evar, value);
};

const initGlobalMatr = (matr) => {
    window.getDeviceUID = undefined;
    _defineDeviceUID(matr?.deviceUid);
};

const hitAudiencies = (event, props) => {
    _satellite?.track(event, { ...props });
};

export { setDigitalData, setGlobalEvar, setGlobalEvars, initGlobalMatr, windowSetGlobalEvar, hitAudiencies };
